<template>
<v-select :loading="loading" :value="value" :items="items" item-text="title" item-value="value" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="v => $emit('input', v)" @change="v => $emit('input', v)">
</v-select>
</template>

<script>
//
export default {
  name: 'MyRpType',
  props: {
    value: {
      // type: String,
      required: true,
    },
    route: {},
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [
        v => !!v || 'فیلد الزامی',
      ],
    }
  },
  methods: {
    async retrieveData() {
      //
      this.loading = true
      try {
        this.items = [{
          value: 'bankReceipt',
          title: 'ح بانکی'
        }, {
          value: 'cash',
          title: 'نقد'
        }, {
          value: 'cheque',
          title: 'چک'
        }, {
          value: 'pos',
          title: 'پوز'
        }]
        if (['payments'].includes(this.route)) {
          this.items.splice(2, 1);
        }
        //
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
}
</script>
